import { ReactElement } from "react";
import NewButton from "../../../components/Atomos/Buttons/newButton";
import { DealmakerCatalogResult } from "../../../Services/DealmakerCatalog";
import DealmakerArchived from "./DealmakerArchived";
import DealmakerCard from "./DealmakerCard";
import DealmakerPager from "./DealmakerPager";
import DealmakerSearchForm from "./DealmakerSearchForm";

interface DealmakerListProps {
  catalog: DealmakerCatalogResult | null;
  loading: boolean;
  error: string;
}

export default function DealmakerList({ catalog, loading, error }: DealmakerListProps): ReactElement {
  return (
    <section>
      <h2 className="dealmaker-heading" id="search">Deal Search</h2>
      <DealmakerSearchForm options={catalog?.options ?? null} />
      <div className="dealmaker-toolbar">
        <a href="/manage_dealmaker.asp?action=add">
          <NewButton text="Submit a Deal" color="primary" style="outlined" />
        </a>
        {catalog ? <DealmakerPager page={catalog.active.page} pageCount={catalog.active.pageCount} pageKey="page" /> : null}
      </div>
      {loading ? <p>Loading deals...</p> : null}
      {error ? <p className="dealmaker-error">{error}</p> : null}
      {catalog && catalog.active.items.length === 0 && !loading ? <p className="dealmaker-empty">No Deal matches with search criteria</p> : null}
      {catalog?.active.items.map((card) => <DealmakerCard key={card.dealId} card={card} />)}
      {catalog ? <DealmakerPager page={catalog.active.page} pageCount={catalog.active.pageCount} pageKey="page" /> : null}
      {catalog ? (
        <DealmakerArchived items={catalog.archived.items} page={catalog.archived.page} pageCount={catalog.archived.pageCount} />
      ) : null}
      <img className="dealmaker-dots" src="https://members-legacy.worldservicesgroup.com/assets/images/dots.png" alt="dots" />
    </section>
  );
}
